import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { SafeHtmlPipe } from '../../../pipes/safe-html.pipe';
import { RdsDividerModule } from '@rds/angular-components';

@Component({
  selector: 'inexp-knowledge-release-notes',
  imports: [CommonModule, SafeHtmlPipe, RdsDividerModule],
  templateUrl: './knowledge-release-notes.component.html',
  styleUrl: './knowledge-release-notes.component.scss',
})
export class KnowledgeReleaseNotesComponent {
  _uid = input<string>();
  component = input<string>();
  knowledgeSection = input<string>();
  releaseNotes = input<any[]>();
  hasPublishedItems(): boolean {
    return this.releaseNotes()?.some(b => b.published === true) ?? false;
  }
}
